import { useEffect, useState, type FC } from "react";
import { Button, DatePicker, Modal, SelectPicker } from "rsuite";
import {
  PriceCategory,
  ProductPrice,
} from "../../../models/inventory/product_price";
import { getPriceCategories } from "../../../services/inventory/PriceCategoryApi";
import CurrencyInput from "react-currency-input-field";

interface PriceFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProductPrice) => void;
  price?: ProductPrice;
}

const PriceForm: FC<PriceFormProps> = ({ open, onClose, onSubmit, price }) => {
  const [priceCategories, setPriceCategories] = useState<PriceCategory[]>([]);
  const [data, setData] = useState<ProductPrice>({
    id: "",
    amount: 0,
    currency: "",
    price_category_id: "",
    effective_date: new Date(),
    min_quantity: 0,
  });

  useEffect(() => {
    getPriceCategories({ page: 1, size: 100 })
      .then((res) => res.json())
      .then((res) => {
        setPriceCategories(res.data.items);
      });
  }, []);
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Price Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Category</label>
            <div className="input">
              <SelectPicker
                block
                data={priceCategories}
                labelKey="name"
                valueKey="id"
                value={data?.price_category_id}
                onChange={(value) => {
                  setData({ ...data, price_category_id: value! });
                }}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Amount</label>
            <CurrencyInput
              className="rs-input"
              value={data.amount}
              groupSeparator="."
              decimalSeparator=","
              onValueChange={(value, name, values) =>
                setData({ ...data, amount: values?.float ?? 0 })
              }
            />
          </div>
          <div className="form-group">
            <label>Min Qty</label>
            <CurrencyInput
              className="rs-input"
              value={data.min_quantity}
              groupSeparator="."
              decimalSeparator=","
              onValueChange={(value, name, values) =>
                setData({ ...data, min_quantity: values?.float ?? 0 })
              }
            />
          </div>
          <div className="form-group">
            <label>Effective Date</label>
            <div className="input">
              <DatePicker
                format="dd MMMM yyyy"
                value={data.effective_date}
                onChange={(value) => {
                  setData({ ...data, effective_date: value! });
                }}
                block
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                amount: 0,
                currency: "",
                price_category_id: "",
                effective_date: new Date(),
                min_quantity: 0,
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default PriceForm;
